<template>
    <v-app class="login-page">
        <v-main class="login-wrapper">

            <!-- Left Pane (Desktop Only) -->
            <div class="login-left">
                <img src="@/assets/image.png" class="bg-image" />
                <img src="@/assets/logo_white.png" class="logo" />
            </div>

            <!-- Right Pane -->
            <div class="login-right">
                <div class="login-form">

                    <!-- Header -->
                    <div class="mb-8">
                        <img src="../assets/logo.png" class="logo-img" alt="Orchard Logo" />
                        <h3 class="text-2xl font-semibold text-gray-900 mt-8">
                            Log in to your account
                        </h3>
                        <p class="text-gray-400 text-xs mt-2">
                            Enter your email and password below to log in
                        </p>
                    </div>

                    <!-- Error -->
                    <v-alert v-if="error" type="error" density="compact" class="mb-4">
                        {{ error }}
                    </v-alert>

                    <!-- Form -->
                    <form @submit.prevent="handleLogin" class="w-full space-y-6">

                        <!-- Email -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Email</label>
                            <input v-model="email" type="email" required placeholder="email@example.com"
                                class="modern-input" />
                        </div>

                        <!-- Password -->
                        <div class="flex flex-col gap-2 spacing text-left w-full mb-4 relative">
                            <label class="text-sm font-medium text-gray-700">Password</label>
                            <input v-model="password" :type="showPassword ? 'text' : 'password'" required
                                placeholder="••••••••" class="modern-input pr-10 w-full" />

                            <!-- Eye icon -->
                            <i :class="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" class="password-icon"
                                @click="togglePassword"></i>
                        </div>

                        <!-- Remember / Forgot -->
                        <div class="w-full flex justify-between justify-between mt-4 text-left spacing">
                           
                            <div class="flex items-center cursor-pointer">
                                <Checkbox v-model="pizza" inputId="ingredient1" name="pizza" value="Cheese" />
                                <label for="ingredient1"> Remember me </label>
                                <!-- Right: Forgot password -->
                                <!--button type="button" @click="forgotPassword"
                                    class="text-sm font-medium text-gray-600 hover:text-black transition-colors m-space">
                                    Forgot password?
                                </button-->
                            </div>


                        </div>
                        <!-- Submit -->
                        <button type="submit" :disabled="loading" class="login-button mt-4">
                            <span v-if="!loading">Log in <v-icon start>mdi-login</v-icon></span>
                            <span v-else>Signing in… <v-icon start class="spin">mdi-loading</v-icon></span>
                        </button>

                    </form>

                </div>
            </div>

        </v-main>
    </v-app>
</template>

<script setup>
import { ref } from "vue"
import { useRouter } from "vue-router"
import { login } from "@/api/auth"
import Checkbox from 'primevue/checkbox';

const router = useRouter()

const email = ref("")
const password = ref("")
const error = ref("")
const loading = ref(false)

/**============= Show or hide password   ================*/
const showPassword = ref(false)

const togglePassword = () => {
    showPassword.value = !showPassword.value
}


const handleLogin = async () => {
    error.value = ""
    loading.value = true
    try {
        const res = await login({
            email: email.value,
            password: password.value,
        })
        localStorage.setItem("token", res.data.data.token)

        //router.push("/dashboard")
        const lastRoute = localStorage.getItem("lastRoute");
        router.push(lastRoute || "/dashboard"); 

    } catch (e) {
        error.value = e.response?.data?.message || "Login failed";
    } finally {
        loading.value = false
    }
}

// const forgotPassword = () => {
//     router.push("/forgot-password")
// }
</script>

<style scoped>
/* Layout */
.login-wrapper {
    display: flex;
    min-height: 100vh;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.logo-img {
    width: 20em;
}

.logo {
    position: absolute;
    bottom: 24px;
    left: 24px;
    width: 130px;
}

.login-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9fafb;
    padding: 24px;
}

.login-form {
    width: 100%;
    max-width: 420px;
}

/* Inputs */
.modern-input {
    width: 100%;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: transparent;
    transition: all 0.2s ease;
}

.modern-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

.password-icon {
    position: absolute;
    right: 14px;
    top: 58px; /* adjust to align perfectly */
    transform: translateY(-50%);
    cursor: pointer;
    color: #6b7280;
    font-size: 1rem;
}

.password-icon:hover {
    color: #111827;
}

.modern-input {
    padding-right: 40px;
}

/* Button */
.login-button {
    width: 100%;
    height: 46px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.login-button:hover {
    background: #292828;
}

.login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spacing {
    margin-bottom: 1em;
}

.m-space {
    margin-left: 9.5rem !important;
}

.modern-input.pr-10 {
    padding-right: 2.5rem;
    /* enough space for eye button */
}

.relative {
    position: relative;
}

/* Button positioned over the input */
.absolute {
    position: absolute;
    cursor: pointer;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Mobile */
@media (max-width: 767px) {
    .login-wrapper {
        flex-direction: column;
    }

    .login-left {
        display: none;
    }

    .m-space {
        margin-left: 7rem !important;
    }
}
</style>
